import React from "react";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/IconButton";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons";

function Navigation({onClose}) {
  return (
    <div className="nav">
      <div className="closeButtonContainer">
        <IconButton onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} className="closeButton" />
        </IconButton>
      </div>
    </div>
  );
}

Navigation.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Placebar/components/PlacebarMenu/PlacebarDropdown/Navigation.jsx